import { pathgen } from 'object-path-generator';
import { useMemo } from 'react';
export const getTestIds = parentTestId => {
  return pathgen(parentTestId ? "".concat(parentTestId, " > ") : undefined);
};
export const useTestIds = parentTestId => {
  return useMemo(() => getTestIds(parentTestId), [parentTestId]);
};